(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['module', 'react'], factory);
    } else if (typeof exports !== "undefined") {
        factory(module, require('react'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.react);
        global.huangbo = mod.exports;
    }
})(this, function (module, React) {
    'use strict';

    function _defaults(obj, defaults) {
        var keys = Object.getOwnPropertyNames(defaults);

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = Object.getOwnPropertyDescriptor(defaults, key);

            if (value && value.configurable && obj[key] === undefined) {
                Object.defineProperty(obj, key, value);
            }
        }

        return obj;
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
    }

    var Huangbo = function (_React$Component) {
        _inherits(Huangbo, _React$Component);

        function Huangbo(props) {
            _classCallCheck(this, Huangbo);

            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

            _this.state = {
                appEntry: 'pc_yl'
            };
            return _this;
        }

        Huangbo.prototype.render = function render() {
            var imgSrc = this.props.imgSrc;


            return React.createElement(
                'div',
                { className: 'js-component-huangbo huangbo' },
                React.createElement(
                    'div',
                    { id: 'js-huangbo-modal', className: 'huangbo-modal' },
                    React.createElement(
                        'div',
                        { className: 'center' },
                        React.createElement(
                            'div',
                            { className: 'part1' },
                            React.createElement(
                                'ul',
                                { className: 'huangbo-swish' },
                                React.createElement(
                                    'li',
                                    { className: 'huangbo-swish-li' },
                                    React.createElement('div', { className: 'huangbo-swish-img' }),
                                    React.createElement(
                                        'div',
                                        { className: 'huangbo-text1' },
                                        '黄渤邀您关注微信'
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'huangbo-text2' },
                                        '更有千元好礼等你拿！'
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'part2' },
                            React.createElement('img', { is: true, 'class': 'huangbo-qr', 'rrc-wechat-entry': '2628', src: imgSrc, alt: '' }),
                            React.createElement(
                                'div',
                                { className: 'huangbo-qr-text' },
                                '第一手的好车推荐'
                            )
                        )
                    )
                )
            );
        };

        return Huangbo;
    }(React.Component);

    module.exports = { Huangbo: Huangbo };
});